import { ThemeProvider } from "@material-ui/styles"
import React from "react"
import { useAppSelector } from "../../app/hooks";

import { theme, testTheme } from '../../theme';

export const AppThemeProvider = (props: React.PropsWithChildren<{}>) => {

  const isTest = useAppSelector(state => {
    return state.inputAnswer.session.cxHttpRes?.isTest;
  });

  let appTheme = theme;
  if (isTest === true) {
    appTheme = testTheme;
  }

  return (
    <ThemeProvider theme={appTheme}>
      {props.children}
    </ThemeProvider>
  )
}
